module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-ExtraBold.1f12ba4.woff2";